import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Support = ({ showNotification }) => {
  const [donationAmount, setDonationAmount] = useState('');
  const [customAmount, setCustomAmount] = useState('');
  const [donationType, setDonationType] = useState('one-time');
  const [selectedPurpose, setSelectedPurpose] = useState('music');
  const [paymentMethod, setPaymentMethod] = useState('swish');
  const [isProcessing, setIsProcessing] = useState(false);
  const [showSwishInstructions, setShowSwishInstructions] = useState(false);
  const [showBankTransferModal, setShowBankTransferModal] = useState(false);
  const [bankTransferDetails, setBankTransferDetails] = useState(null);
  const [donorInfo, setDonorInfo] = useState({
    name: '',
    email: '',
    phone: '',
    anonymous: false
  });

  const { t } = useTranslation();

  // Icônes SVG
  const Icons = {
    Music: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
      </svg>
    ),
    Globe: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
      </svg>
    ),
    Heart: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
    ),
    Equipment: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"/>
      </svg>
    ),
    Swish: () => (
      <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      </svg>
    ),
    Card: () => (
      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
      </svg>
    ),
    PayPal: () => (
      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
        <path d="M7.5 14.25c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 10.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z"/>
      </svg>
    ),
    Bank: () => (
      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2L1 8v2h22V8L12 2zm0 4.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM3 13v7h4v-7H3zm6 0v7h4v-7H9zm6 0v7h4v-7h-4z"/>
      </svg>
    ),
    Security: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
      </svg>
    ),
    Loading: () => (
      <svg className="w-5 h-5 animate-spin" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/>
      </svg>
    ),
    QrCode: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 1h10v10H1V1zm2 2h6v6H3V3zm-2 12h10v10H1V15zm2 2h6v6H3v-6zM13 1h10v10H13V1zm2 2h6v6h-6V3zm6 12h2v2h-2v2h2v2h2v-2h2v2h2v-2h2v-2h-2v-2h2v-2h-2v2h-2v-2h-2v2zm0 4v2h2v-2h-2zm-6-2h10v10H13V15zm2 2h6v6h-6v-6z"/>
      </svg>
    ),
    Copy: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
      </svg>
    )
  };

  const presetAmounts = [100, 250, 500, 1000, 2500, 5000];
  
  const donationPurposes = [
    {
      id: 'music',
      title: t('support.purposes.music.title'),
      description: t('support.purposes.music.description'),
      verse: t('support.purposes.music.verse'),
      impact: t('support.purposes.music.impact'),
      icon: <Icons.Music />
    },
    {
      id: 'missions',
      title: t('support.purposes.missions.title'),
      description: t('support.purposes.missions.description'),
      verse: t('support.purposes.missions.verse'),
      impact: t('support.purposes.missions.impact'),
      icon: <Icons.Globe />
    },
    {
      id: 'humanitarian',
      title: t('support.purposes.humanitarian.title'),
      description: t('support.purposes.humanitarian.description'),
      verse: t('support.purposes.humanitarian.verse'),
      impact: t('support.purposes.humanitarian.impact'),
      icon: <Icons.Heart />
    },
    {
      id: 'equipment',
      title: t('support.purposes.equipment.title'),
      description: t('support.purposes.equipment.description'),
      verse: t('support.purposes.equipment.verse'),
      impact: t('support.purposes.equipment.impact'),
      icon: <Icons.Equipment />
    }
  ];

  const handleSwishPayment = async (amount) => {
    const purposeInfo = donationPurposes.find(p => p.id === selectedPurpose);
    const message = t('support.swish.message', { 
      purpose: purposeInfo?.title 
    });
    
    const swishNumber = '+46 76 565 95 51';
    const swishAppUrl = `swish://payment?token=${swishNumber}&amount=${amount}&message=${encodeURIComponent(message)}`;
    
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobile) {
      window.location.href = swishAppUrl;
      
      setTimeout(() => {
        setShowSwishInstructions(true);
      }, 2000);
    } else {
      setShowSwishInstructions(true);
    }

    return {
      success: true,
      transactionId: `SWISH${Date.now()}`,
      method: 'Swish',
      purpose: purposeInfo?.title,
      details: {
        number: swishNumber,
        amount: amount,
        message: message
      }
    };
  };

  const handlePayment = async (amount, donorInfo, paymentType) => {
    const transactionId = `${paymentType.toUpperCase()}${Date.now()}`;
    const purposeInfo = donationPurposes.find(p => p.id === selectedPurpose);
    const purposeText = purposeInfo?.title || t('support.defaultPurpose');
    
    switch (paymentType) {
      case 'swish':
        return await handleSwishPayment(amount);
        
      case 'card':
        showNotification(t('support.messages.stripeConfig'), 'info');
        return { 
          success: false, 
          transactionId: transactionId, 
          method: t('support.paymentMethods.card'), 
          purpose: purposeText,
          details: t('support.messages.useSwishOrPaypal')
        };
        
      case 'paypal':
        const paypalAmount = parseFloat(amount);
        const paypalUrl = `https://paypal.me/IsayaEsaieWilondja/${paypalAmount}SEK`;
        
        window.open(paypalUrl, '_blank', 'noopener,noreferrer');
        
        return { 
          success: true, 
          transactionId: transactionId, 
          method: 'PayPal', 
          purpose: purposeText,
          details: t('support.messages.redirectPaypal'),
          url: paypalUrl
        };
        
      case 'bank':
        const reference = `DON-ESA${Date.now().toString().slice(-6)}`;
        
        return { 
          success: true, 
          transactionId: transactionId, 
          method: t('support.paymentMethods.bank'),
          purpose: purposeText,
          bankDetails: {
            iban: 'SE31 3000 0000 0311 8045 8265',
            bic: 'NDEASESS',
            bank: 'Nordea Bank',
            holder: 'Isaya Esaie Wilondja',
            reference: reference,
            amount: amount,
            message: t('support.bank.message', { purpose: purposeText })
          }
        };
        
      default:
        throw new Error(t('support.errors.unsupportedMethod'));
    }
  };

  const handleDonation = async (e) => {
    e.preventDefault();
    
    const amount = donationAmount || customAmount;
    if (!amount || amount < 10) {
      showNotification(t('support.errors.invalidAmount'), 'error');
      return;
    }

    if (!donorInfo.anonymous && (!donorInfo.name || !donorInfo.email)) {
      showNotification(t('support.errors.missingInfo'), 'error');
      return;
    }

    setIsProcessing(true);

    try {
      const result = await handlePayment(amount, donorInfo, paymentMethod);
      
      if (result.success) {
        if (paymentMethod === 'bank') {
          setBankTransferDetails(result);
          setShowBankTransferModal(true);
          
          showNotification(
            t('support.messages.bankInstructions', { amount: amount }),
            'success'
          );
          
        } else if (paymentMethod === 'swish') {
          showNotification(
            t('support.messages.swishProcessing', { 
              amount: amount, 
              purpose: result.purpose 
            }),
            'success'
          );
        } else {
          showNotification(
            t('support.messages.donationProcessing', { 
              amount: amount, 
              purpose: result.purpose 
            }),
            'success'
          );
          
          setDonationAmount('');
          setCustomAmount('');
          setDonorInfo({
            name: '',
            email: '',
            phone: '',
            anonymous: false
          });
        }
      }
    } catch (error) {
      showNotification(t('support.errors.paymentError'), 'error');
    } finally {
      setIsProcessing(false);
    }
  };

  const selectedPurposeData = donationPurposes.find(p => p.id === selectedPurpose);

  const paymentMethods = [
    {
      id: 'swish',
      name: t('support.paymentMethods.swish'),
      icon: <Icons.Swish />,
      description: t('support.paymentMethods.swishDesc'),
      recommended: true,
      details: t('support.paymentMethods.swishDetails'),
      action: 'swish'
    },
    {
      id: 'paypal',
      name: t('support.paymentMethods.paypal'),
      icon: <Icons.PayPal />,
      description: t('support.paymentMethods.paypalDesc'),
      recommended: false,
      details: t('support.paymentMethods.paypalDetails'),
      action: 'paypal'
    },
    {
      id: 'bank',
      name: t('support.paymentMethods.bank'),
      icon: <Icons.Bank />,
      description: t('support.paymentMethods.bankDesc'),
      recommended: false,
      details: t('support.paymentMethods.bankDetails'),
      action: 'bank'
    }
  ];

  const SwishInstructionsModal = () => {
    if (!showSwishInstructions) return null;
    
    const amount = donationAmount || customAmount;
    const purposeInfo = donationPurposes.find(p => p.id === selectedPurpose);
    const message = t('support.swish.message', { 
      purpose: purposeInfo?.title 
    });

    return (
      <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-gradient-to-b from-gray-900 to-black rounded-2xl p-8 max-w-md w-full border border-yellow-700/30"
        >
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-2xl font-bold text-white flex items-center gap-2">
              <Icons.Swish />
              {t('support.swish.title')}
            </h3>
            <button
              onClick={() => setShowSwishInstructions(false)}
              className="text-gray-400 hover:text-white text-2xl"
            >
              ×
            </button>
          </div>

          <div className="text-center mb-6">
            <div className="bg-white p-2 rounded-xl inline-block mb-4">
              <img 
                src="/assets/images/swishqr.jpg" 
                alt={t('support.swish.qrAlt')}
                className="w-40 h-40"
              />
            </div>
            
            <p className="text-gray-300 mb-2">
              {t('support.swish.scanQR')}
            </p>
            <p className="text-sm text-gray-500 mb-4">
              {t('support.swish.orFollow')}
            </p>
          </div>

          <div className="space-y-4 mb-6">
            <div className="bg-gray-900/50 p-4 rounded-xl">
              <div className="text-gray-400 text-sm mb-1">
                {t('support.swish.amount')}
              </div>
              <div className="text-2xl font-bold text-yellow-600">{amount} SEK</div>
            </div>
            
            <div className="bg-gray-900/50 p-4 rounded-xl">
              <div className="text-gray-400 text-sm mb-1">
                {t('support.swish.number')}
              </div>
              <div className="text-xl font-bold text-white">+46 76 565 95 51</div>
            </div>
            
            <div className="bg-gray-900/50 p-4 rounded-xl">
              <div className="text-gray-400 text-sm mb-1">
                {t('support.swish.message')}
              </div>
              <div className="text-white">{message}</div>
            </div>
          </div>

          <div className="bg-yellow-900/20 border border-yellow-700/30 rounded-xl p-4 mb-6">
            <h4 className="font-bold text-yellow-500 mb-2 flex items-center gap-2">
              <Icons.QrCode />
              {t('support.swish.instructions')}
            </h4>
            <ol className="text-gray-300 text-sm space-y-2 pl-5 list-decimal">
              <li>{t('support.swish.step1')}</li>
              <li>{t('support.swish.step2')}</li>
              <li>{t('support.swish.step3')}</li>
              <li>{t('support.swish.step4')}</li>
              <li>{t('support.swish.step5')}</li>
            </ol>
          </div>

          <div className="flex gap-3">
            <button
              onClick={() => setShowSwishInstructions(false)}
              className="flex-1 py-3 border border-gray-700 text-gray-400 rounded-xl hover:bg-gray-800 hover:text-white transition-colors duration-300"
            >
              {t('support.buttons.close')}
            </button>
            
            <button
              onClick={() => {
                navigator.clipboard.writeText('+46 76 565 95 51');
                showNotification(t('support.messages.copiedNumber'), 'success');
                
                const button = document.getElementById('copySwishButton');
                if (button) {
                  button.innerHTML = `<span class="flex items-center justify-center gap-2">✅ <span>${t('support.buttons.copied')}</span></span>`;
                  button.disabled = true;
                  button.className = 'flex-1 py-3 bg-green-600 text-white rounded-xl font-medium transition-all duration-300';
                  
                  setTimeout(() => {
                    button.innerHTML = `<span>${t('support.buttons.copyNumber')}</span>`;
                    button.disabled = false;
                    button.className = 'flex-1 py-3 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white rounded-xl font-medium hover:opacity-90 transition-all duration-300';
                  }, 2000);
                }
              }}
              id="copySwishButton"
              className="flex-1 py-3 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white rounded-xl font-medium hover:opacity-90 transition-all duration-300"
            >
              <span>{t('support.buttons.copyNumber')}</span>
            </button>
          </div>
        </motion.div>
      </div>
    );
  };

  const BankTransferModal = () => {
    if (!showBankTransferModal || !bankTransferDetails) return null;

    const handleCopy = (text, message) => {
      navigator.clipboard.writeText(text);
      showNotification(message, 'success');
    };

    return (
      <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-gradient-to-b from-gray-900 to-black rounded-2xl p-8 max-w-lg w-full border border-yellow-700/30 max-h-[90vh] overflow-y-auto"
        >
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-2xl font-bold text-white flex items-center gap-2">
              <Icons.Bank />
              {t('support.bank.title')}
            </h3>
            <button
              onClick={() => {
                setShowBankTransferModal(false);
                setDonationAmount('');
                setCustomAmount('');
                setDonorInfo({
                  name: '',
                  email: '',
                  phone: '',
                  anonymous: false
                });
              }}
              className="text-gray-400 hover:text-white text-2xl"
            >
              ×
            </button>
          </div>

          <div className="space-y-4 mb-6">
            <div className="bg-yellow-900/20 p-4 rounded-xl border border-yellow-700/30">
              <p className="text-yellow-400 text-center font-medium">
                {t('support.bank.useInfo')}
              </p>
            </div>

            <div className="bg-gray-900/50 p-4 rounded-xl">
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-gray-400 text-sm mb-1">
                    {t('support.bank.amount')}
                  </div>
                  <div className="text-2xl font-bold text-yellow-600">
                    {bankTransferDetails.bankDetails?.amount || donationAmount || customAmount} SEK
                  </div>
                </div>
                <button
                  onClick={() => handleCopy(
                    bankTransferDetails.bankDetails?.amount || donationAmount || customAmount,
                    t('support.messages.copiedAmount')
                  )}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <Icons.Copy className="w-4 h-4 text-gray-400" />
                </button>
              </div>
            </div>
            
            <div className="bg-gray-900/50 p-4 rounded-xl">
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-gray-400 text-sm mb-1">
                    {t('support.bank.reference')}
                  </div>
                  <div className="text-xl font-bold text-white">
                    {bankTransferDetails.bankDetails?.reference || 'DON-ESA' + Date.now().toString().slice(-6)}
                  </div>
                </div>
                <button
                  onClick={() => handleCopy(
                    bankTransferDetails.bankDetails?.reference || 'DON-ESA' + Date.now().toString().slice(-6),
                    t('support.messages.copiedReference')
                  )}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <Icons.Copy className="w-4 h-4 text-gray-400" />
                </button>
              </div>
            </div>
            
            <div className="bg-gray-900/50 p-4 rounded-xl">
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-gray-400 text-sm mb-1">
                    {t('support.bank.holder')}
                  </div>
                  <div className="text-white text-lg">Isaya Esaie Wilondja</div>
                </div>
                <button
                  onClick={() => handleCopy('Isaya Esaie Wilondja', t('support.messages.copiedName'))}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <Icons.Copy className="w-4 h-4 text-gray-400" />
                </button>
              </div>
            </div>
            
            <div className="bg-gray-900/50 p-4 rounded-xl">
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-gray-400 text-sm mb-1">IBAN</div>
                  <div className="text-yellow-400 font-mono text-lg">
                    SE31 3000 0000 0311 8045 8265
                  </div>
                </div>
                <button
                  onClick={() => handleCopy('SE31 3000 0000 0311 8045 8265', t('support.messages.copiedIBAN'))}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <Icons.Copy className="w-4 h-4 text-gray-400" />
                </button>
              </div>
            </div>
            
            <div className="bg-gray-900/50 p-4 rounded-xl">
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-gray-400 text-sm mb-1">BIC/SWIFT</div>
                  <div className="text-white font-medium text-lg">NDEASESS</div>
                </div>
                <button
                  onClick={() => handleCopy('NDEASESS', t('support.messages.copiedBIC'))}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <Icons.Copy className="w-4 h-4 text-gray-400" />
                </button>
              </div>
            </div>
            
            <div className="bg-gray-900/50 p-4 rounded-xl">
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-gray-400 text-sm mb-1">
                    {t('support.bank.bank')}
                  </div>
                  <div className="text-white text-lg">Nordea Bank, Suède</div>
                </div>
                <button
                  onClick={() => handleCopy('Nordea Bank, Suède', t('support.messages.copiedBank'))}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <Icons.Copy className="w-4 h-4 text-gray-400" />
                </button>
              </div>
            </div>
            
            <div className="bg-gray-900/50 p-4 rounded-xl">
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-gray-400 text-sm mb-1">
                    {t('support.bank.message')}
                  </div>
                  <div className="text-white">
                    {bankTransferDetails.bankDetails?.message || bankTransferDetails.purpose || t('support.defaultPurpose')}
                  </div>
                </div>
                <button
                  onClick={() => handleCopy(
                    bankTransferDetails.bankDetails?.message || bankTransferDetails.purpose || t('support.defaultPurpose'),
                    t('support.messages.copiedMessage')
                  )}
                  className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                >
                  <Icons.Copy className="w-4 h-4 text-gray-400" />
                </button>
              </div>
            </div>
          </div>

          <div className="bg-blue-900/20 border border-blue-700/30 rounded-xl p-4 mb-6">
            <h4 className="font-bold text-blue-400 mb-2">
              {t('support.bank.important')}
            </h4>
            <ul className="text-gray-300 text-sm space-y-2 pl-5 list-disc">
              <li>{t('support.bank.instruction1')}</li>
              <li>{t('support.bank.instruction2')}</li>
              <li>{t('support.bank.instruction3')}</li>
              <li>{t('support.bank.instruction4')}</li>
              <li>{t('support.bank.instruction5')}</li>
            </ul>
          </div>

          <div className="flex gap-3">
            <button
              onClick={() => {
                setShowBankTransferModal(false);
                setDonationAmount('');
                setCustomAmount('');
                setDonorInfo({
                  name: '',
                  email: '',
                  phone: '',
                  anonymous: false
                });
              }}
              className="flex-1 py-3 border border-gray-700 text-gray-400 rounded-xl hover:bg-gray-800 hover:text-white transition-colors duration-300"
            >
              {t('support.buttons.close')}
            </button>
            
            <button
              onClick={() => {
                const text = `${t('support.bank.allInfo')}:
${t('support.bank.amount')}: ${bankTransferDetails.bankDetails?.amount || donationAmount || customAmount} SEK
${t('support.bank.reference')}: ${bankTransferDetails.bankDetails?.reference}
${t('support.bank.holder')}: Isaya Esaie Wilondja
IBAN: SE31 3000 0000 0311 8045 8265
BIC: NDEASESS
${t('support.bank.bank')}: Nordea Bank, Suède
${t('support.bank.message')}: ${bankTransferDetails.bankDetails?.message || bankTransferDetails.purpose}`;
                
                navigator.clipboard.writeText(text);
                showNotification(t('support.messages.copiedAllInfo'), 'success');
              }}
              className="flex-1 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-medium hover:opacity-90 transition-all duration-300 flex items-center justify-center gap-2"
            >
              <Icons.Copy />
              <span>{t('support.buttons.copyAll')}</span>
            </button>
          </div>
        </motion.div>
      </div>
    );
  };

  return (
    <>
      <div className="pt-24 min-h-screen bg-gradient-to-b from-black via-gray-900 to-black">
        {/* Hero Section */}
        <section className="relative py-16 text-center">
          <div className="absolute inset-0 bg-gradient-to-b from-yellow-900/10 via-black to-black"></div>
          
          <div className="relative z-10 max-w-6xl mx-auto px-4">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-yellow-700 via-yellow-600 to-yellow-500 bg-clip-text text-transparent"
            >
              {t('support.title')}
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-2xl text-gray-300 mb-8 max-w-3xl mx-auto"
            >
              {t('support.subtitle')}
            </motion.p>
          </div>
        </section>

        {/* Main Content */}
        <div className="py-12">
          <div className="max-w-6xl mx-auto px-4">
            <div className="grid lg:grid-cols-2 gap-8">
              {/* Formulaire de Don */}
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:col-span-1"
              >
                <div className="bg-gradient-to-b from-gray-900 to-black rounded-2xl p-8 border border-gray-800 shadow-2xl">
                  <h2 className="text-3xl font-bold mb-2 text-white text-center">
                    {t('support.form.title')}
                  </h2>
                  <p className="text-gray-400 mb-8 text-center">
                    {t('support.form.subtitle')}
                  </p>

                  <form onSubmit={handleDonation} className="space-y-8">
                    {/* Type de Don */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-300 mb-4">
                        {t('support.form.donationType')}
                      </label>
                      <div className="grid grid-cols-2 gap-3">
                        {[
                          { id: 'one-time', label: t('support.form.oneTime') },
                          { id: 'monthly', label: t('support.form.monthly') }
                        ].map((type) => (
                          <button
                            key={type.id}
                            type="button"
                            onClick={() => setDonationType(type.id)}
                            className={`p-4 rounded-xl border-2 text-center transition-all duration-200 ${
                              donationType === type.id
                                ? 'border-yellow-600 bg-gradient-to-r from-yellow-900/30 to-yellow-800/20 text-yellow-400 font-semibold'
                                : 'border-gray-700 text-gray-400 hover:border-gray-600 hover:text-gray-300 bg-gray-900/50'
                            }`}
                          >
                            <div className="flex items-center justify-center gap-2">
                              <span>{type.label}</span>
                            </div>
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* Informations Donateur */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-300 mb-4">
                        {t('support.form.donorInfo')}
                      </label>
                      <div className="space-y-4">
                        <div className="grid md:grid-cols-2 gap-4">
                          <input
                            type="text"
                            placeholder={t('support.form.placeholders.name')}
                            value={donorInfo.name}
                            onChange={(e) => setDonorInfo({...donorInfo, name: e.target.value})}
                            disabled={donorInfo.anonymous}
                            className="w-full px-4 py-3 border border-gray-700 rounded-lg bg-gray-900 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 disabled:bg-gray-800"
                          />
                          <input
                            type="email"
                            placeholder={t('support.form.placeholders.email')}
                            value={donorInfo.email}
                            onChange={(e) => setDonorInfo({...donorInfo, email: e.target.value})}
                            disabled={donorInfo.anonymous}
                            className="w-full px-4 py-3 border border-gray-700 rounded-lg bg-gray-900 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 disabled:bg-gray-800"
                          />
                        </div>
                        <input
                          type="tel"
                          placeholder={t('support.form.placeholders.phone')}
                          value={donorInfo.phone}
                          onChange={(e) => setDonorInfo({...donorInfo, phone: e.target.value})}
                          disabled={donorInfo.anonymous}
                          className="w-full px-4 py-3 border border-gray-700 rounded-lg bg-gray-900 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 disabled:bg-gray-800"
                        />
                        <label className="flex items-center gap-3">
                          <input
                            type="checkbox"
                            checked={donorInfo.anonymous}
                            onChange={(e) => setDonorInfo({...donorInfo, anonymous: e.target.checked})}
                            className="w-4 h-4 text-yellow-600 focus:ring-yellow-500 border-gray-700 bg-gray-900"
                          />
                          <span className="text-sm text-gray-400">
                            {t('support.form.anonymous')}
                          </span>
                        </label>
                      </div>
                    </div>

                    {/* Destination du Don */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-300 mb-4">
                        {t('support.form.donationPurpose')}
                      </label>
                      <div className="grid gap-3">
                        {donationPurposes.map((purpose) => (
                          <label key={purpose.id} className="flex items-start gap-3 cursor-pointer p-4 border border-gray-800 rounded-xl hover:border-yellow-600 transition-colors bg-gray-900/50">
                            <input
                              type="radio"
                              name="purpose"
                              value={purpose.id}
                              checked={selectedPurpose === purpose.id}
                              onChange={(e) => setSelectedPurpose(e.target.value)}
                              className="mt-1 text-yellow-600 focus:ring-yellow-600"
                            />
                            <div className="flex-1">
                              <div className="flex items-center gap-2 mb-2">
                                <span className="text-yellow-600">{purpose.icon}</span>
                                <span className="font-medium text-white">{purpose.title}</span>
                              </div>
                              <p className="text-sm text-gray-400">{purpose.description}</p>
                            </div>
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* Montant du Don */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-300 mb-4">
                        {t('support.form.donationAmount')} (SEK)
                      </label>
                      
                      <div className="grid grid-cols-3 gap-3 mb-6">
                        {presetAmounts.map((amount) => (
                          <button
                            key={amount}
                            type="button"
                            onClick={() => {
                              setDonationAmount(amount.toString());
                              setCustomAmount('');
                            }}
                            className={`p-3 rounded-xl border-2 text-center transition-all duration-200 ${
                              donationAmount === amount.toString()
                                ? 'border-yellow-600 bg-gradient-to-r from-yellow-900/30 to-yellow-800/20 text-yellow-300 font-semibold'
                                : 'border-gray-700 text-gray-400 hover:border-gray-600 hover:text-gray-300 bg-gray-900/50'
                            }`}
                          >
                            {amount} SEK
                          </button>
                        ))}
                      </div>

                      <div className="relative">
                        <input
                          type="number"
                          value={customAmount}
                          onChange={(e) => {
                            setCustomAmount(e.target.value);
                            setDonationAmount('');
                          }}
                          placeholder={t('support.form.placeholders.customAmount')}
                          className="w-full px-4 py-3 border border-gray-700 rounded-lg bg-gray-900 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                          min="10"
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                          <span className="text-gray-500">SEK</span>
                        </div>
                      </div>
                    </div>

                    {/* Méthode de Paiement */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-300 mb-4">
                        {t('support.form.paymentMethod')}
                      </label>
                      <div className="grid gap-3">
                        {paymentMethods.map((method) => (
                          <label key={method.id} className="flex items-center gap-4 cursor-pointer p-4 border border-gray-800 rounded-xl hover:border-yellow-600 transition-colors bg-gray-900/50">
                            <input
                              type="radio"
                              name="paymentMethod"
                              value={method.id}
                              checked={paymentMethod === method.id}
                              onChange={(e) => setPaymentMethod(e.target.value)}
                              className="text-yellow-600 focus:ring-yellow-600"
                            />
                            <span className="text-yellow-600">{method.icon}</span>
                            <div className="flex-1">
                              <div className="flex items-center gap-2 mb-1">
                                <span className="font-medium text-white">{method.name}</span>
                                {method.recommended && (
                                  <span className="bg-yellow-900 text-yellow-400 text-xs px-3 py-1 rounded-full">
                                    {t('support.recommended')}
                                  </span>
                                )}
                              </div>
                              <p className="text-sm text-gray-400">{method.description}</p>
                              <p className="text-xs text-gray-500 mt-1">{method.details}</p>
                            </div>
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* Bouton de Soumission */}
                    <motion.button
                      type="submit"
                      disabled={isProcessing}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      className="w-full bg-gradient-to-r from-yellow-600 via-yellow-600 to-yellow-700 hover:from-yellow-700 hover:via-yellow-700 hover:to-yellow-800 disabled:opacity-50 text-white py-4 rounded-xl font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-yellow-500/20 flex items-center justify-center gap-3"
                    >
                      {isProcessing ? (
                        <>
                          <Icons.Loading />
                          <span>{t('support.buttons.processing')}</span>
                        </>
                      ) : (
                        <>
                          <Icons.Security />
                          <span>
                            {t('support.buttons.donate')} {donationAmount || customAmount || '-'} SEK
                          </span>
                        </>
                      )}
                    </motion.button>

                    <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
                      <Icons.Security />
                      <span>{t('support.security')}</span>
                    </div>
                  </form>
                </div>
              </motion.div>

              {/* Informations */}
              <div className="lg:col-span-1 space-y-8">
                <motion.div
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  className="bg-gradient-to-br from-yellow-900/20 to-black/50 rounded-2xl p-8 border border-yellow-700/30"
                >
                  <div className="flex items-center gap-4 mb-6">
                    <div className="p-3 bg-gradient-to-br from-yellow-900/40 to-yellow-800/20 rounded-xl border border-yellow-600/30">
                      <span className="text-yellow-500">{selectedPurposeData?.icon}</span>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white">
                        {selectedPurposeData?.title}
                      </h3>
                      <p className="text-gray-400">{t('support.selectedProject')}</p>
                    </div>
                  </div>
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    {selectedPurposeData?.description}
                  </p>
                  <div className="space-y-4">
                    <div className="bg-gradient-to-r from-yellow-900/20 to-transparent p-4 rounded-xl border border-yellow-700/20">
                      <p className="text-yellow-400 italic">
                        « {selectedPurposeData?.verse} »
                      </p>
                    </div>
                    <div className="bg-yellow-900/10 p-4 rounded-xl">
                      <p className="text-yellow-400 font-medium">
                        ✨ {selectedPurposeData?.impact}
                      </p>
                    </div>
                  </div>
                </motion.div>

                {/* Swish Info Card */}
                {paymentMethod === 'swish' && (
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="bg-gradient-to-r from-green-900/20 to-emerald-900/10 rounded-2xl p-6 border border-green-700/30"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <Icons.Swish />
                      <h3 className="text-xl font-bold text-white">{t('support.swish.title')}</h3>
                    </div>
                    <p className="text-gray-300 mb-4">
                      {t('support.swish.requirements')}
                    </p>
                    <ul className="text-gray-400 space-y-2 mb-6">
                      <li className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                        {t('support.swish.requirement1')}
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                        {t('support.swish.requirement2')}
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                        {t('support.swish.requirement3')}
                      </li>
                    </ul>
                    <div className="bg-green-900/20 p-4 rounded-xl">
                      <p className="text-green-400 text-sm">
                        <span className="font-bold">{t('support.note')}:</span> {t('support.swish.note')}
                      </p>
                    </div>
                  </motion.div>
                )}

                {/* Bank Transfer Info */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-8 border border-gray-800"
                >
                  <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
                    <Icons.Bank />
                    <span>{t('support.bank.transfer')}</span>
                  </h3>
                  <div className="space-y-4">
                    <div className="bg-gray-900/50 p-4 rounded-xl">
                      <div className="text-gray-400 text-sm mb-1">
                        {t('support.bank.holder')}
                      </div>
                      <div className="text-white font-medium">Isaya Esaie Wilondja</div>
                    </div>
                    <div className="bg-gray-900/50 p-4 rounded-xl">
                      <div className="text-gray-400 text-sm mb-1">IBAN</div>
                      <div className="text-yellow-400 font-mono">SE31 3000 0000 0311 8045 8265</div>
                    </div>
                    <div className="bg-gray-900/50 p-4 rounded-xl">
                      <div className="text-gray-400 text-sm mb-1">BIC/SWIFT</div>
                      <div className="text-white font-medium">NDEASESS</div>
                    </div>
                    <div className="bg-gray-900/50 p-4 rounded-xl">
                      <div className="text-gray-400 text-sm mb-1">
                        {t('support.bank.bank')}
                      </div>
                      <div className="text-white">Nordea Bank</div>
                    </div>
                  </div>
                </motion.div>

                {/* Contact */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                  className="bg-gradient-to-br from-gray-900/50 to-black/50 rounded-2xl p-8 border border-gray-800"
                >
                  <h3 className="text-2xl font-bold text-white mb-6">
                    {t('support.help.title')}
                  </h3>
                  <p className="text-gray-400 mb-6">
                    {t('support.help.description')}
                  </p>
                  <div className="space-y-4">
                    <div className="flex items-center gap-4 p-4 bg-gray-900/30 rounded-xl">
                      <div className="p-2 bg-yellow-900/20 rounded-lg">
                        <svg className="w-6 h-6 text-yellow-500" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
                        </svg>
                      </div>
                      <div>
                        <div className="text-sm text-gray-500">{t('support.help.supportEmail')}</div>
                        <div className="text-white font-medium">esaiemusic@gmail.com</div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4 p-4 bg-gray-900/30 rounded-xl">
                      <div className="p-2 bg-yellow-900/20 rounded-lg">
                        <svg className="w-6 h-6 text-yellow-500" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                        </svg>
                      </div>
                      <div>
                        <div className="text-sm text-gray-500">{t('support.help.phone')}</div>
                        <div className="text-white font-medium">+46 76 56 59 551</div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Swish */}
      <SwishInstructionsModal />

      {/* Modal Virement Bancaire */}
      <BankTransferModal />
    </>
  );
};

export default Support;